/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthMemberLoginResponse } from "./AuthMemberLoginResponse";

export type AuthMemberLoginResponseApiRespoonse = {
  data?: AuthMemberLoginResponse;
  status?: AuthMemberLoginResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AuthMemberLoginResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
